import request from '../../utils/request';

// 分类
export async function addSpuCategoryRequest(params) {
  return request({ url: 'cxmProductSpuCategory/add', params, headers: 'json' });
}
export async function updateSpuCategoryRequest(params) {
  return request({ url: 'cxmProductSpuCategory/update', params, headers: 'json' });
}
export async function deleteSpuCategoryRequest(id) {
  return request({ url: `cxmProductSpuCategory/delete/${id}`, method: 'delete', headers: 'json' });
}
export async function getSpuCategoryPageRequest(params) {
  return request({ url: 'cxmProductSpuCategory/page', params, method: 'get', headers: 'json' });
}
export async function getSpuCategoryTreeListRequest(params) {
  return request({ url: 'cxmProductSpuCategory/treeList', params, method: 'get', headers: 'json' });
}
// 基库货品
export async function addSpuRequest(params) {
  return request({ url: 'cxmProductSpu/add', params, headers: 'json' });
}
export async function editSpuRequest(params) {
  return request({ url: 'cxmProductSpu/edit', params, headers: 'json' });
}
export async function countSpuRequest(params) {
  return request({ url: 'cxmProductSpu/count', params, method: 'get', headers: 'json' });
}
export async function deleteSpuRequest(id) {
  return request({ url: `cxmProductSpu/delete/${id}`, method: 'delete', headers: 'json' });
}
export async function mergeSpuRequest(params) {
  return request({ url: 'cxmProductSpu/merge', params, headers: 'json' });
}
export async function pageSpuRequest(params) {
  return request({ url: 'cxmProductSpu/page', params, method: 'get', headers: 'json' });
}
export async function pageSpuRelationRequest(params) {
  return request({ url: 'cxmProductSpuRelation/page', params, method: 'get', headers: 'json' });
}
export async function addSpuRelationRequest(params) {
  return request({ url: 'cxmProductSpuRelation/add', params, headers: 'json' });
}
export async function deleteSpuRelationRequest({ stallId, productId }) {
  return request({
    url: `cxmProductSpuRelation/delete/${stallId}/${productId}`,
    method: 'delete',
    headers: 'json',
  });
}
